<template>
    <div>
        <router-view v-if="loaded"></router-view>
    </div>
</template>

<script>

export default {
    name: "RestaurateurLayout",
    data: function () {
        return {
            loaded: false
        }
    },
    mounted() {
        let loader = this.$loading.show();
        this.$store.dispatch('updateRestaurateurData')
            .then(() => {
                this.loaded = true;
            })
            .finally(() => {
                loader.hide();
            });
    }
}
</script>